export class WebContratoSeguroPerguntas {
    idSeqPergunta : Number;
    idPlano : Number;
    idPergunta : Number;
    nmPergunta : string;
}